var map = {
	"./Door to Door.svg": 9279,
	"./Issue tracking.svg": 8742,
	"./closeButton.svg": 5958,
	"./home.svg": 8835,
	"./loan.svg": 488,
	"./menu.svg": 691,
	"./mobilisation.svg": 2722,
	"./supporters.svg": 8381,
	"./survey.svg": 2336
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3636;